import React, { useCallback } from 'react';
import { useFormikContext } from 'formik';

import { Button } from '../Inputs';
import { SubmitButtonProps } from './types';

export default function SubmitButton({
    as: Component = Button,
    isInitialHidden = false,
    onClick = undefined,
    ...rest
}) {
    const { submitForm, dirty, isSubmitting } = useFormikContext();
    const isHidden = !dirty && isInitialHidden;

    const handleClick = useCallback((e) => {
        e.preventDefault();
        submitForm();
    });

    if (isHidden) return null;

    return <Component isFetching={isSubmitting} disabled={!dirty} onClick={onClick || handleClick} {...rest} />;
}

SubmitButton.propTypes = SubmitButtonProps;
